import { createApp } from "vue";
import { Quasar } from "quasar";
import { createPinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";
import Maps from "@fawmi/vue-google-maps";
import router from "./router";
import App from "./App.vue";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";
import "quasar/src/css/flex-addon.sass";
import { queryClient } from "./services/queryClientConfig";
import Bugsnag from "./bugsnag";
import { registerGlobalComponents } from "./plugins/global-components";

const pinia = createPinia();
const myApp = createApp(App);

myApp.use(Bugsnag.getPlugin('vue').installVueErrorHandler(myApp))

myApp.use(Quasar, {
  plugins: {}, // import Quasar plugins and add here
});

registerGlobalComponents(myApp);

myApp.use(Maps, {
  load: {
    key: `${process.env.API_MAPS}`,
    libraries: "places",
  },
});

myApp.use(pinia);
pinia.use(piniaPluginPersistedstate);

myApp.use(router);
myApp.use(VueQueryPlugin, { queryClient });
myApp.mount("#app");
